/* Lente de zoom na imagem do produto — Loja Varietah
 *
 * Mostra um circulo que segue o cursor sobre a imagem principal e exibe
 * a regiao sob ele ampliada. Nao substitui o fancybox: o clique continua
 * abrindo a imagem em tela cheia (a lente tem pointer-events: none).
 *
 * Config via data-attributes no container .product-single__media:
 *   data-vzoom-size  diametro do circulo em px   (padrao 180)
 *   data-vzoom-level fator de ampliacao          (padrao 2.5)
 */
(function () {
  'use strict';

  var CONTAINER = '.product-single__media';
  var IMG = 'img.product-featured-media, img.feature-row__image';
  var DEFAULT_SIZE = 180;
  var DEFAULT_LEVEL = 2.5;
  var HIRES_WIDTH = 1600;

  // Em touch nao existe hover: a lente ficaria parada onde o dedo tocou.
  function hasMouse() {
    return window.matchMedia &&
           window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  // O tema serve data-src com um template "{width}" (padrao lazysizes).
  // Trocamos por uma largura alta para a lente ter o que ampliar.
  function hiResUrl(img) {
    var tpl = img.getAttribute('data-src') || '';
    if (tpl.indexOf('{width}') !== -1) return tpl.replace('{width}', HIRES_WIDTH);

    // Sem template: tenta o href do fancybox (imagem master), depois o src atual.
    var link = img.closest ? img.closest('a[data-fancybox], a.fancybox') : null;
    if (link && link.getAttribute('href')) return link.getAttribute('href');

    return img.currentSrc || img.src || '';
  }

  // O valor pode estar no proprio container ou no container da secao,
  // que e onde o Liquid escreve os settings.
  function num(el, attr, fallback) {
    var node = el.hasAttribute(attr) ? el : (el.closest ? el.closest("[" + attr + "]") : null);
    if (!node) return fallback;
    var v = parseFloat(node.getAttribute(attr));
    return isNaN(v) || v <= 0 ? fallback : v;
  }

  function setup(container) {
    if (container.vzoomReady) return;
    var img = container.querySelector(IMG);
    if (!img) return;

    var size = num(container, 'data-vzoom-size', DEFAULT_SIZE);
    var level = num(container, "data-vzoom-level", DEFAULT_LEVEL * 10) / 10;

    var lens = document.createElement('div');
    lens.className = 'vzoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    lens.style.width = size + 'px';
    lens.style.height = size + 'px';
    container.appendChild(lens);

    container.classList.add('vzoom-host', 'vzoom-host--ready');
    img.classList.add('vzoom-target');
    container.vzoomReady = true;

    var url = '';
    var pending = false;
    var lastX = 0, lastY = 0;

    function loadUrl() {
      var next = hiResUrl(img);
      if (!next || next === url) return;
      url = next;
      lens.style.backgroundImage = 'url("' + url.replace(/"/g, '\\"') + '")';
    }

    function paint() {
      pending = false;
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;

      var x = lastX - r.left;
      var y = lastY - r.top;

      // Sobra entre a borda da foto e a do container: ali a lente nao tem o
      // que mostrar. Esconder, em vez de congelar na ultima posicao valida.
      if (x < 0 || y < 0 || x > r.width || y > r.height) {
        lens.classList.remove('vzoom-lens--on');
        return;
      }

      // A imagem de fundo e a foto ampliada; deslocamos para que o ponto
      // sob o cursor caia no centro do circulo.
      var bgW = r.width * level;
      var bgH = r.height * level;
      var posX = (x * level) - (size / 2);
      var posY = (y * level) - (size / 2);

      lens.style.backgroundSize = bgW + 'px ' + bgH + 'px';
      lens.style.backgroundPosition = (-posX) + 'px ' + (-posY) + 'px';

      // Posicao do circulo relativa ao container (que e position: relative).
      var c = container.getBoundingClientRect();
      lens.style.left = (lastX - c.left) + 'px';
      lens.style.top = (lastY - c.top) + 'px';

      if (url) lens.classList.add('vzoom-lens--on');
    }

    function onMove(e) {
      lastX = e.clientX;
      lastY = e.clientY;
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(paint);
      }
    }

    function onEnter(e) {
      if (!hasMouse()) return;
      loadUrl();
      if (!url) return;
      onMove(e);
    }

    function onLeave() {
      lens.classList.remove('vzoom-lens--on');
    }

    container.addEventListener('mouseenter', onEnter);
    container.addEventListener('mousemove', onMove);
    container.addEventListener('mouseleave', onLeave);

    // lazysizes troca o src depois; refaz a URL quando a imagem final chega.
    img.addEventListener('load', function () { url = ''; loadUrl(); });

    // Pre-carrega a versao ampliada em momento ocioso. Sem isso, o primeiro
    // hover acende um circulo branco enquanto a imagem chega — parece defeito.
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () { loadUrl(); }, { timeout: 3000 });
    } else {
      window.setTimeout(function () { loadUrl(); }, 1200);
    }
  }

  function scan() {
    if (!hasMouse()) return;
    var list = document.querySelectorAll(CONTAINER);
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // A galeria troca de slide e o tema recarrega blocos; reavalia sob demanda.
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();
